import {
  Box,
  Button,
  ButtonLink,
  DialogDescription,
  Typography,
} from '@branch-messenger/willow-ui'
import { use } from 'react'

import UserVerificationIllustration from '@/assets/illustrations/user-verification.svg?react'
import { IconList } from '@/components/icon-list'
import { DialogContext } from '@/context'
import { useOrg } from '@/selectors/organization'

import { useOnboardingUrl } from '../root/hooks/useOnboardingUrl'
import { useAppFeaturesList } from './hooks/useAppFeaturesList'
import { AppFeaturesListContainer, LargeDialogTitle } from './styles'

export const AppPayoutsModalContent = () => {
  const {
    data: { orgInfo },
  } = useOrg()
  const { hideDialog } = use(DialogContext)

  const onboardingUrl = useOnboardingUrl()
  const appFeaturesList = useAppFeaturesList()

  return (
    <Box $display="flex" $direction="column" $gap={6} $align="initial">
      <Box $display="flex" $justify="center">
        <UserVerificationIllustration />
      </Box>
      <Box $display="flex" $direction="column" $gap={4} $align="initial">
        <LargeDialogTitle>
          {'Get paid with the'}
          <div>{`${orgInfo?.app_display_name} App`}</div>
        </LargeDialogTitle>
        <DialogDescription>
          {`Open a Branch account to receive secure payouts—for free. To protect your account, we’ll need to verify your identity. No credit check required.`}
        </DialogDescription>
      </Box>
      <Box $display="flex" $direction="column" $gap={4} $align="initial">
        <Typography $size={'xl'} $bold>
          Why use Branch for your payouts?
        </Typography>
        <Box $display="flex" $direction="column" $gap={2} $align="initial">
          <AppFeaturesListContainer>
            <IconList items={appFeaturesList} />
          </AppFeaturesListContainer>
          <Typography $size="xs" $color="textMuted" $italicized>
            *Funds are available as soon as they are deposited. Transfers to
            external accounts may be subject to delays.
          </Typography>
        </Box>
      </Box>
      <Box $display="flex" $justify="flex-end" $gap={2}>
        <Button
          type="button"
          color="tertiary"
          variant="outlined"
          onClick={hideDialog}
        >
          Cancel
        </Button>
        <ButtonLink href={onboardingUrl}>Continue</ButtonLink>
      </Box>
    </Box>
  )
}
